import { useLocation, useNavigate } from "react-router-dom";

export type TabItem = {
  id: string;
  label: string;
  ic: string;       // Icon-Glyph (Emoji oder Unicode)
  to: string;
  badge?: number;   // optionale rote Zahl (z.B. offene Aufgaben); >0 wird angezeigt
};

type Props = {
  items: TabItem[];
  /** Default: olive. Falls eine App andere Akzent-Farbe will. */
  accentColor?: string;
};

/**
 * Fix angedockte Bottom-Tab-Bar.
 * Anzahl der Spalten richtet sich automatisch nach items.length.
 * Aktive Tab erkennt sich per location.pathname.startsWith(item.to).
 */
export function MTabs({ items, accentColor }: Props) {
  const loc = useLocation();
  const navigate = useNavigate();
  return (
    <nav className="m-tabs" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
      {items.map(t => {
        const active = loc.pathname.startsWith(t.to);
        return (
          <button
            key={t.id}
            className={`m-tab ${active ? "is-on" : ""}`}
            onClick={() => navigate(t.to)}
            style={active && accentColor ? { color: accentColor } : undefined}
          >
            <span className="m-tab-ic" style={{ position: "relative", display: "inline-block" }}>
              {t.ic}
              {t.badge && t.badge > 0 ? (
                <span style={{
                  position: "absolute", top: -6, right: -12, minWidth: 16, height: 16,
                  padding: "0 4px", borderRadius: 999, background: "var(--m-red, #e08272)",
                  color: "#fff", fontSize: 10, fontWeight: 800, lineHeight: "16px",
                  textAlign: "center", boxSizing: "border-box",
                }}>{t.badge > 99 ? "99+" : t.badge}</span>
              ) : null}
            </span>
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
